// extracted by mini-css-extract-plugin
export default {"fields":"fkEXHH","time":"b2Ebik","mobile":"nqIeTV"};